import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import User from '../../../models/user';

class Teammates extends Component {
  static propTypes = {
    spotId: PropTypes.string.isRequired,
    user: PropTypes.instanceOf(User),
    userId: PropTypes.string.isRequired,
    onItemSelected: PropTypes.func.isRequired,
    addUser: PropTypes.func
  };

  static displayName = 'Teammates';

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  @autobind
  addToTeam() {
    let { userId, onItemSelected, addUser, user } = this.props;
    addUser({
      userId,
      user,
      roles: ['team_member']
    });
    onItemSelected();
  }

  render() {
    return (
      <div className="buttons">
        <div className="buttons-assign">
          <span className="add-to-team-button" onClick={this.addToTeam}>
            + Add to team
          </span>
        </div>
      </div>
    );
  }
}

export default Teammates;
